<div class="TransitionPageContainer">
  <!-- <div class="banner">
    </div> -->
  <nav *ngIf="!data.isModal" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a (click)="goHome()">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Transition Project
      </li>
    </ol>
  </nav>
  <div class="wrapperPane">
    <div class="leftPane">
      <div class="actionsWrapper">
        <label class="pageTitle">Transition Project</label>
        <div class="dataFilterContainer">
          <div
            motifDropdown
            ngClass="dataFilter"
            placement="bottom-right"
            scrollStrategy="reposition"
            [autoClose]="true"
            [closeOnBackdropClick]="true"
            [open]="false"
          >
            <button
              aria-label="Dropdown toggle example"
              motifDropdownToggle
              id="selectQuarterDropdown"
            >
              <span>{{ visibleTransition.transition.projectName }}</span>
              <motif-icon
                [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"
              ></motif-icon>
            </button>
            <div motifDropdownMenu aria-labelledby="selectQuarterDropdown">
              <button
                (click)="setSelectedTransition(item.id)"
                motifDropdownItem
                [ngClass]="{
                  active: item.projectName === visibleTransition.transition.projectName
                }"
                *ngFor="let item of transitions"
              >
                {{ item.projectName }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="transitionCard">
        <div
          class="ALCardBanner"
          [ngStyle]="{
            background:
              'url(' +
              visibleTransition.transition.headerImageUrl +
              ') 0% 0% / cover rgba(0, 0, 0, 0.3)'
          }"
        >
          <p
            class="ALRAGLabel"
            [ngClass]="{
              green: visibleTransition.transition.rag === 'On Track',
              red: visibleTransition.transition.rag === 'At Risk',
              yellow: visibleTransition.transition.rag === 'Delayed'
            }"
          >
            {{ visibleTransition.transition.rag }}
          </p>
          <div class="completionChartWrapper">
            <app-donut-chart
            *ngIf="billableHoursChartData.length"
          [donutChartData]="billableHoursChartData"
          [name]="'billableHours'"
          [width]="width"
          [height]="height"
          [strokeWidth]="strokeWidth"
        ></app-donut-chart>
            <div class="chartLabel">
              <span class="percent">{{visibleTransition.transition.projectCompletion}}%</span>
              <span class="">completed</span>
            </div>
          </div>
          
        </div>
        <div class="ALCardContent">
          <div class="details">
          <div class="ALHeader">
            <label>Project Description</label>
            <span>{{ visibleTransition.transition.projectDescription }}</span>
          </div>
          <div class="ALContent">
            <motif-avatar
              size="small"
              [src]="$any(userService.userDetails?.pictureBase64)"
              [userName]="$any(userService.userDetails?.displayName)"
            >
            </motif-avatar>
            <!-- <img [src]="visibleTransition.projectTypeIconUrl"/> -->
            <div class="right-content">
              <div>
                <label class="transition-label"
                  ><img src="/assets/images/people_outline.svg" /> PROJECT
                  MANAGER</label
                >
                <p class="label-data">{{ visibleTransition.transition.clientName }}</p>
              </div>
              <div>
                <label class="transition-label"
                  ><img src="/assets/images/Calendar 1.svg" />PROJECT
                  DURATION</label
                >
                <p class="label-data">
                  {{ visibleTransition.transition.projectStart | date : "dd/MM/yyyy" }}
                  <img src="/assets/images/Vector.svg" />
                  {{ visibleTransition.transition.projectEnd | date : "dd/MM/yyyy" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="status">
          <div class="ALHeader">            
            <label class="attention">
              <img src="/assets/images/red.svg" />Attention</label>
          </div>
          <div class="content-switcher">
            <button *ngFor="let item of (visibleTransition.highPriority | keyvalue)" (click)="openDetailsModal(item.key, item.value)">
              <span class="number">{{item.value.length}}</span>
              <span>{{item.key}}</span>
            </button>
          </div>
          <!-- <motif-content-switcher>
           
            <motif-content-switcher-option
            *ngFor="let item of (visibleTransition.status | keyvalue)"
            value="{{item.value.length}} {{item.key}}"
            ></motif-content-switcher-option>
          </motif-content-switcher> -->
        </div>
        </div>

      </div>
      <div class="transitionMoreDetails">
        <div class="tollGate">
          <label>Toll Gates</label>
          <ng-container *ngIf="visibleTransition.projectTollgate.length">
          <div class="tollCard"  *ngFor="let projectTollgate of visibleTransition.projectTollgate">
            <span>{{projectTollgate.tollgate}} | {{projectTollgate.deliverable}}</span>
            <span class="labelText">{{projectTollgate.description}}</span>
          </div>
        </ng-container>
          <div *ngIf="visibleTransition.projectTollgate.length === 0" class="noDataContaner">
            <span>No Data</span>
          </div>
        </div>
        <div class="budget">
          <label> Budget</label>
          <div class="budgetWrapper">
          <div class="budgetCard">
            <span *ngIf="visibleTransition.projectBudget ">{{visibleTransition.projectBudget.overallBudget}}K</span>
            <span *ngIf="!visibleTransition.projectBudget">0 K</span>
            <span class="labelText">Overall Budget</span>
          </div>
          <div class="budgetCard">
            <span *ngIf="visibleTransition.projectBudget">{{visibleTransition.projectBudget.costIncurred}}K</span>
            <span *ngIf="!visibleTransition.projectBudget">0 K</span>
            <span class="labelText">Cost Incurred</span>
          </div>
          <div class="budgetCard">
            <span *ngIf="visibleTransition.projectBudget">{{visibleTransition.projectBudget.estimateCompletion}}K</span>
            <span *ngIf="!visibleTransition.projectBudget">0 K</span>
            <span class="labelText">Estimate to Completion</span>
          </div>
          <div class="budgetCard">
            <span *ngIf=" visibleTransition.projectBudget && visibleTransition.projectBudget.isPositive" class="percentBudget green"><img src="/assets/images/graph_green.svg"/>{{visibleTransition.projectBudget.percentOfChange}}</span>
            <span *ngIf=" visibleTransition.projectBudget && !visibleTransition.projectBudget.isPositive" class="percentBudget red"><img src="/assets/images/graph_red.svg"/>{{visibleTransition.projectBudget.percentOfChange}}</span>
            <span class="labelText"> Percentage of Change</span>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="rightPane">
      <label>Milestones</label>
      <div class="milestoneWrapper">
        <div class="filterContainer">
          <div class="dataFilterContainer">
            <div
              motifDropdown
              ngClass="dataFilter"
              placement="bottom-right"
              scrollStrategy="reposition"
              [autoClose]="true"
              [closeOnBackdropClick]="true"
              [open]="false"
            >
              <button
                aria-label="Dropdown toggle example"
                motifDropdownToggle
                id="selectQuarterDropdown"
              >
                <span>{{selectedMilestoneTimeline}}</span>
                <motif-icon
                  [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"
                ></motif-icon>
              </button>
              <div motifDropdownMenu aria-labelledby="selectQuarterDropdown">
                <button
                  motifDropdownItem
                  (click)="showMilestones(item)"
                  [ngClass]="{
                    active: item === selectedMilestoneTimeline
                  }"
                  *ngFor="let item of mileStoneTimelines"
                >
                  {{item}}
                </button>
              </div>
            </div>
          </div>
          <div class="filterImage">
            <label>Timeline</label>
            <img src="/assets/images/Timeline icon 1.svg"/>
            <img src="/assets/images/Timeline icon 2.svg"/>
          </div>
        </div>
        <div class="milestoneDetails">
          <div class="milestoneLabel"> 
            <label>Date</label>
            <label>Milestone Details</label>
          </div>
          <div *ngFor="let monthYear of sortedMonthYears" class="timeline">
            <div class="timeline-month"><label>{{ monthYear }}</label></div>
            <div class="timeline-events">
              <div class="event-card" *ngFor="let milestone of sortedMilestones[monthYear]">
                <div class="event-circle" [ngClass]="{
                  'past': milestone.isPast,
                  'upcoming': milestone.isUpcoming
                }"></div>
                <div class="event-content" [ngClass]="{
                  'past': milestone.isPast,
                  'upcoming': milestone.isUpcoming
                }">
                  <label>{{ milestone.milestoneDetail }}</label>
                  <div><span>{{ milestone.startDate | date : "dd/MM/yyyy" }}</span> 
                    <img src="/assets/images/Vectorblack.svg" />
                  <span>{{ milestone.endDate | date : "dd/MM/yyyy"}}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="sortedMonthYears.length === 0" class="noDataContaner">
            <span>No Milestones</span>
          </div>
          <div class="legendDetails">
            <div class="legend"><span class="past">Past</span></div>
            <div class="legend "><span class="upcoming">Upcoming</span></div>
            <div class="legend "><span class="future">Future</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!visibleTransition" class="noDataContaner">
    <span>No Data</span>
  </div>
</div>
